import customFunc from '@/util/util';

/**
 * 80325 校验工标只能投1-4类职业
 * @param {*} orderClauseList
 * @param {*} profession - 职业大类
 * @param {*} productId
 */
export const validateGongbiaoJob80325 = ({ orderClauseList, profession, productId }) => {
  if (productId + '' !== '80325') return '';
  const clauseCode = 'GP8032562239910';
  // 伤残赔付标准
  const scpfbz = orderClauseList.find((clause) => clause.clauseCode === clauseCode);
  let isGongbiao = scpfbz?.selected?.showValue?.includes('工标');
  if (!isGongbiao) {
    return '';
  }
  if (+profession.val > 4) {
    return '工标仅支持1-4类职业';
  }
  return '';
};

// 80325 校验工标只能投1-4类职业 - 对每个计划的校验
export const validateGongbiaoJob80325ForSchemes = ({
  schemes,
  orderClauseList,
  isQuotePage,
  productId,
}) => {
  if (productId + '' !== '80325') {
    return '';
  }
  for (let i = 0; i < schemes.length; i++) {
    const scheme = schemes[i];
    let professions = scheme.professions;
    if (isQuotePage) {
      professions = scheme.professionList;
    }
    for (let j = 0; j < professions.length; j++) {
      const profession = isQuotePage ? professions[j].professions : professions[j];
      const errMsg = validateGongbiaoJob80325({
        orderClauseList,
        profession,
        productId,
      });
      if (errMsg) {
        return `${errMsg}，请修改计划${customFunc.numberToChinese(i + 1)}中第${
          j + 1
        }个职业，或修改伤残赔付标准`;
      }
    }
  }
  return '';
};



// WEBPACK FOOTER //
// ./src/mixin/special/special-80325.js